module.exports = __webpack_public_path__ + "src/assets/img/garanty_card.93317a6f.jpg";